import { PIXEL_URL } from "@/config";

export const fakeRequest = async (success = true, timeOut = 1000): Promise<string> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (success) resolve("ok");
      else reject("bad");
    }, timeOut);
  });
};

export const extractNumericValue = (cssValue: string = ""): number | undefined => {
  if (!cssValue) return undefined;

  const numericValue = parseFloat(cssValue);
  return isNaN(numericValue) ? undefined : numericValue;
};

export const extractUnit = (cssValue: string = ""): string | undefined => {
  const unit = cssValue.match(/[a-zA-Z%]+$/);
  return unit ? unit[0] : undefined;
};

export const getUniversalPixel = (account: string) =>
  `<!--Iceberger Pixel Starts-->
      <script src="${PIXEL_URL}/universal-pixel.min.js?id=${account}" async></script>
<!--Iceberger Pixel End-->`;

// Vite-inlined, not Node's process — see the note in src/config/index.ts.
declare const process: { env: Record<string, string | undefined> };

export const isDev = process.env.NODE_ENV === "development";
